import Vue from 'vue';
import App from './App.vue';
import router from './routes';
import { store } from './store';
import VueShortkey from 'vue-shortkey';
import VeeValidate from 'vee-validate';
import br from 'vee-validate/dist/locale/pt_BR';
import VueNotification from '@kugatsu/vuenotification';

Vue.use(VueNotification, {
  timer: 5,
  success: {
    background: '#1ab394',
    color: 'white',
  },
  error: {
    background: '#c9302c',
    color: 'white',
  },
});

import VueTheMask from 'vue-the-mask';
import money from 'v-money';
import Toasted from 'vue-toasted';
import vClickOutside from 'v-click-outside';
import * as GmapVue from 'gmap-vue';
import { GOOGLE_API_KEY } from './config/config';
import VoerroTagsInput from '@voerro/vue-tagsinput';

Vue.component('tags-input', VoerroTagsInput);
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 2000,
});
Vue.use(VueTheMask);

Vue.use(vClickOutside);
Vue.use(VueShortkey);

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  precision: 2,
});

Vue.use(VeeValidate, { locale: 'pt_BR', dictionary: { pt_BR: br } });

Vue.config.productionTip = false;

Vue.use(GmapVue, {
  load: {
    key: GOOGLE_API_KEY,

    libraries: 'visualization', // This is required if you use the Autocomplete plugin
  },
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
